import { Navigate, Route, Routes } from "react-router-dom";
import React from "react";

import "./main.scss";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Home from "./pages/home/Home";
import Login from "./pages/login/Login";

import AllRestaurants from "./pages/restaurants/AllRestaurants";
import Landing from "./pages/main/Landing";

function App() {
  return (
    <>
      <ToastContainer
        position="top-center"
        autoClose={200}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      />{" "}
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/admin/" element={<Login />} />
        <Route path="/admin/home" element={<Home />} />
        <Route path="/admin/all-restaurants" element={<AllRestaurants />} />
        <Route path="/*" element={<Navigate to="/" />} />
      </Routes>{" "}
    </>
  );
}

export default App;
